module.exports = __webpack_public_path__ + "static/media/meal.be2151f4.mp4";